export default __webpack_public_path__ + "955587b033f08dbec8caa629b9312a82.svg";